import {
  Application,
  KybDocument,
  KybDocumentStatus,
  KybDocumentType,
  KybReview,
  KybReviewStatus,
} from '__generated__/GQL';
import assertNever from 'common/bento/lib/assertNever';
import getIsEi from 'features/Onboarding/common/isEi';

import { VerificationStatus } from '../../Verification/lib/steps/types';
import getCompanyPapersDocumentType from './getCompanyPapersDocumentType';

const getCompanyPapersStatus = ({
  company,
  isAccountHolder,
  kybDocuments,
  lastKybReview,
  legalForm,
}: {
  kybDocuments: Pick<KybDocument, 'type' | 'status'>[];
  legalForm: string;
  company: Pick<Application, 'isCapitalDeposit' | 'isShineStart'>;
  isAccountHolder: boolean;
  lastKybReview: Pick<KybReview, 'status'> | null;
}) => {
  if (company.isCapitalDeposit || company.isShineStart || !isAccountHolder) {
    return VerificationStatus.Irrelevant;
  }

  const isEi = getIsEi(legalForm);

  /**
   * Ignore this step onboarding non-EI company if we have the pseudo-KBIS
   */
  if (
    !isEi &&
    kybDocuments.some(({ type }) => type === KybDocumentType.InpiNotice)
  ) {
    return VerificationStatus.Irrelevant;
  }

  const registrationDoc = kybDocuments.find(
    ({ type }) =>
      type ===
      getCompanyPapersDocumentType({
        isEi,
      }),
  );

  if (!registrationDoc) {
    return VerificationStatus.ToDo;
  }

  switch (registrationDoc.status) {
    case KybDocumentStatus.Pending: {
      return lastKybReview?.status === KybReviewStatus.Prechecked
        ? VerificationStatus.Validated
        : VerificationStatus.Completed;
    }

    case KybDocumentStatus.Validated:
      return VerificationStatus.Validated;

    case KybDocumentStatus.Refused:
      return VerificationStatus.Invalid;

    case KybDocumentStatus.Missing:
      return VerificationStatus.ToDo;

    default:
      return assertNever(registrationDoc.status);
  }
};

export default getCompanyPapersStatus;
